// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2A9GV","rootNoMargin":"styles_rootNoMargin__2bGbT"};